import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { FindPolicyInfoModalComponent } from '../../../../routes/signup/signup-process/find-policy-info-modal/find-policy-info-modal.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input , NO_ERRORS_SCHEMA, NgZone } from '@angular/core';
import { FormGroup, FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { UserService } from '../../../../_services/user.service';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { environment } from '@env/environment';
import { AddPolicyDataService } from '../../../../_services/signup-process-service/add-policy-data.service';
import { TranslateService } from '@ngx-translate/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { ReferrerUrlService } from '../../../../_services/misc-services/referrer-url.service';
import { CompanyTypeService } from '../../../../_services/_iam/company-type.service';
import { Capacitor } from '@capacitor/core';
import { EmailService } from '../../../../_services/email/email.service';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';

declare const grecaptcha: any;

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, FindPolicyInfoModalComponent, MapfreButtonComponent],
  selector: 'app-create-account-form',
  templateUrl: './create-account-form.component.html',
  providers: [FormBaseControlService, ReferrerUrlService],
})
export class CreateAccountFormComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  signUpForm: FormGroup;
  loading = false;
  user: any = {};
  loader = false;
  siteKey = '';
  public aFormGroup: FormGroup;
  captchaSuccess = false;
  captchaResponse;
  policyNumber: any;
  isCommercialAc: any;
  noOfAttempts = 0;
  isAcmic = false;
  utmQueryParamsStr: string;
  utmQueryParams: {[key:string]: string};

  constructor(
    private authService: AuthenticationService,
    private ipt: FormBaseControlService,
    private router: Router,
    private userData: UserService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private errorRedirectionService: ErrorRedirectionService,
    private ngZone: NgZone,
    private addPolicyDataService: AddPolicyDataService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private acmicService: AcmicService,
    private referrerUrlService: ReferrerUrlService,
    private companyTypeService: CompanyTypeService,
    private emailService: EmailService,
    private activatedRoute: ActivatedRoute,
    private paramHandlingService: ParamHandlingService
  ) {
    this.detectState();
  }

  detectState() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  addPolicyToObject() {
    this.policyNumber =
      this.signUpForm.value.addPolicyOnSignUp &&
      this.signUpForm.value.addPolicyOnSignUp != ''
        ? this.signUpForm.value.addPolicyOnSignUp.trim()
        : this.signUpForm.value.addPolicyOnSignUp;
    const policyDetail = {
        policynumber: { policyNumber: this.policyNumber },
      },
      userAndPolicy = {
        userDetails: { ...this.user.userDetails },
        policyDetail: { ...policyDetail },
      };
    return userAndPolicy;
  }
  createUserObject(object, numbers, publicId): void {
    if (numbers === null) {
      this.user.userDetails = {
        firstName: object.signUpFirst_name.trim(),
        middleName: object.signUpMI_name ? object.signUpMI_name.trim() : '',
        lastName: object.signUpLast_name.trim(),
        dateOfBirth: object.signUpDob,
        zipCode: object.noPhoneEmail_zipcode,
      };
    } else {
      this.user.userDetails['publicId'] = publicId;
      this.user.policyDetail = numbers;
    }
    this.userData.placeUserInfoInStorage(this.user);
    this.userData.setCommercialAcFlag(false);
    this.userData.updateUser(this.user);
  }

  fromTheBackButton(): void {
    this.userData.$user.subscribe((user: any) => {
      if (user && user.userDetails && user.userDetails.lastName !== '') {
        this.signUpForm.controls.signUpFirst_name.setValue(
          user.userDetails.firstName || ''
        );
        this.signUpForm.controls.signUpLast_name.setValue(
          user.userDetails.lastName || ''
        );
        this.signUpForm.controls.signUpDob.setValue(
          user.userDetails.dateOfBirth || ''
        );
        this.signUpForm.controls.noPhoneEmail_zipcode.setValue(
          user.userDetails.zipCode || ''
        );
      }
    });
  }
  getPhoneListObj(result) {
    return  [
      {
        number: result.homePhone ? result.homePhone : '',
        type: 'home',
      },
      {
        number: result.mobilePhone ? result.mobilePhone : '',
        type: 'cell',
      },
      {
        number: result.workPhone ? result.workPhone : '',
        type: 'work',
      },
    ];
  }
  setUserDetailsWhenComapanyExists(result, companyName?) {
    if (
      companyName &&
      (companyName === 'AAA' || companyName === 'MAPFRE')
    ) {
      this.user.userDetails = {
        ...this.user.userDetails,
        firstName: result.firstName,
        lastName: result.lastName,
      };
    }
  }
  updateUserAndNavigate(insuredEmail, insuredPhone, companyName) {
    if (!this.isAcmic && companyName && companyName === 'AAA') {
      this.userData.updateUser(this.user);
      this.router.navigate(['/my-insurance', 'error-not-found']);
    } else if (
      companyName &&
      companyName !== 'AAA' &&
      companyName !== 'MAPFRE'
    ) {
      this.userData.updateUser(this.user);
      this.router.navigate(['signup', 'activate-email']);
    } else if (insuredEmail && insuredPhone) {
      this.user.userDetails.email = insuredEmail;
      this.user.userDetails.phone = insuredPhone;
      this.userData.updateUser(this.user);
      //this.router.navigate(['signup', 'validate-account-email-phone']);
      if(this.isAcmic && Object.keys(this.utmQueryParams).length ) {
        this.router.navigate(['signup', 'validate-account-email-phone'], { queryParams: this.utmQueryParams, queryParamsHandling: 'merge'});
        }else {
          this.router.navigate(['signup', 'validate-account-email-phone'])
        }
    } else if (insuredEmail) {
      this.user.userDetails.email = insuredEmail;
      this.userData.updateUser(this.user);
      if(this.isAcmic && Object.keys(this.utmQueryParams).length ) {
      this.router.navigate(['signup', 'validate-email'], { queryParams: this.utmQueryParams, queryParamsHandling: 'merge'});
      }else {
        this.router.navigate(['signup', 'validate-email'])
      }
    } else if (insuredPhone) {
      this.user.userDetails.phone = insuredPhone;
      this.userData.updateUser(this.user);
      this.router.navigate(['signup', 'validate-phone']);
    }
  }
  onSuccessResponse(result, res, companyName?) {
    if (result) {
      this.loader = false;
      this.setUserDetailsWhenComapanyExists(result, companyName);
      this.user.userDetails = {
        ...this.user.userDetails,
        phoneList: this.getPhoneListObj(result),
      };
      const insuredEmail = result.email;
      const insuredPhone =
        result.mobilePhone || result.homePhone || result.workPhone;
      res.policynumber.push({ policyNumber: this.policyNumber });
      this.updateUserAndNavigate(insuredEmail, insuredPhone, companyName);      
      this.createUserObject(this.signUpForm.value, res, result.publicId);
    }
  }
  onError400(err) {
    this.gTagService.triggerFormLink(
      'signUpForm',
      'false',
      this.translate.instant('ACCOUNT_EXISTS')
    );
    const emailId = err.error.Message.split(':')[0];
    this.router.navigate(['signup', 'account-exists'], {
      queryParams: {
        email: this.emailService.maskEmail(emailId || ''),
      },
    });
  }
  onError403(err) {
    if (err.error && err.error.Message === 'WRONG_COMPANY_AAA') {
      this.incorrectUserDataHandler();
      this.sendReferrerUrl();
    } else if (
      err.error &&
      err.error.Message === 'EMAIL_&_PHONE_NOT_PRESENT'
    ) {
      if (this.isAcmic) {
        this.router.navigate(['signup', 'add-policy-error']);
      } else {
        this.router.navigate(['signup', 'acount-verification']);
      }
    } else {
      this.incorrectUserDataHandler();
    }
  }
  onErrorResponse(err) {
    if (err.status === 400) {
      this.onError400(err);      
    } else if (err.status === 403) {
      this.onError403(err);
    } else {
      this.gTagService.triggerFormLink(
        'signUpForm',
        'false',
        this.translate.instant('REGISTRATION_ERROR')
      );
      this.errorRedirectionService.errorRedirectHandler(err);
    }
  }
  validateCustomerForCreateAccount(res, companyName?) {
    this.authService
      .validateCustomer(this.userData, this.signUpForm.value.addPolicyOnSignUp, this.captchaResponse)
      .subscribe(
        (result: any) => {
          this.gTagService.triggerFormLink('signUpForm', 'true', '');
          this.onSuccessResponse(result, res, companyName);          
        },
        (err) => {
          this.loader = false;
          this.onErrorResponse(err);          
        }
      );
  }
  getCompany(res) {
    this.companyTypeService
    .getCompanyName(this.signUpForm.value.addPolicyOnSignUp)
    .subscribe((company) => {
      if (company && company.companyName !== 'AAA') {
        sessionStorage.setItem('companyName', company.companyName);
      }
      this.validateCustomerForCreateAccount(res, company.companyName);
    });
  }
  whenPolicyStartsWith800803() {
    if (this.router.url === '/my-insurance/link-policy') {
      this.router.navigate([
        '/my-insurance',
        'business-policy-not-supported',
      ]);
    } else {
      this.router.navigate(['signup', 'bop']);
    }
  }
  routeOrCreateAccount(res) {
    if (
      this.policyNumber &&
      this.policyNumber.startsWith('800803') &&
      this.policyNumber.length === 13
    ) {
      this.whenPolicyStartsWith800803();      
      this.loader = false;
    } else if (this.userData) {
      if (this.isAcmic || Capacitor.isNativePlatform()) {
        const companyName = this.isAcmic ? 'AAA' : '';
        this.validateCustomerForCreateAccount(res, companyName);
      } else {
        this.getCompany(res);        
      }
    }
  }
  register() {
    if (this.loader) {
      return false;
    }
    if (this.noOfAttempts > 10) {
      this.router.navigate(['signup', 'x-attempts']);
      return;
    }
    this.loading = true;
    this.loader = true;
    this.executeRecaptchaEnterprise().then((token) => {
      if (!token) {
        this.loading = false;
        this.loader = false;
        this.captchaSuccess = false;
        return;
      }
      this.handleSuccess(token);
      this.createUserObject(this.signUpForm.value, null, null);
      this.addPolicyDataService.updateAddPolicy(this.addPolicyToObject());
      const res = {
        policynumber: [],
      };
      this.routeOrCreateAccount(res);
    });
  }
  incorrectUserDataHandler() {
    this.gTagService.triggerFormLink(
      'signUpForm',
      'false',
      this.translate.instant('INCORRECT_USER_DETAILS')
    );
    // in correct user details
    this.router.navigate(['signup', 'not-found']);
  }
  sendReferrerUrl() {
    this.referrerUrlService
      .postReferrer(
        { referrer: document.referrer },
        this.signUpForm.value.addPolicyOnSignUp
      )
      .subscribe(() => {
        console.log('Referrer Url Was Posted');
      });
  }
  prefillData(prefillData): void {
    if (!prefillData) {
      return;
    }
    this.signUpForm
      .get('signUpFirst_name')
      .setValue(prefillData.userDetails.firstName);
    this.signUpForm
      .get('signUpLast_name')
      .setValue(prefillData.userDetails.lastName);
    this.signUpForm
      .get('signUpDob')
      .setValue(prefillData.userDetails.dateOfBirth);
    this.signUpForm
      .get('noPhoneEmail_zipcode')
      .setValue(prefillData.userDetails.zipCode);
    this.signUpForm
      .get('addPolicyOnSignUp')
      .setValue(prefillData.policyDetail.policynumber.policyNumber);
  }

  ngOnInit() {
    this.siteKey = environment.siteKey;
    this.isCommercialAc = this.userData.getCommercialAcFlag();
    this.signUpForm = this.ipt.toFormGroup(this.inputs);
    this.fromTheBackButton();
    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe();
    }
    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.prefillData(userData);
    });
    this.userData.$user.subscribe((user) => {
      if (user && !user.addPolicyAttempts) {
        user.addPolicyAttempts = 0;
      }
      this.noOfAttempts = user && user.addPolicyAttempts;
    });
    this.setUtmQueryParams();
    this.utmQueryParams =  this.paramHandlingService.getUtmQueryParams();
    this.loadRecaptchaEnterpriseScript();
  }

  loadRecaptchaEnterpriseScript(): void {
    const scriptId = 'recaptcha-enterprise-script';
    if (document.getElementById(scriptId)) {
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error('Failed to load reCAPTCHA Enterprise script. Check CSP script-src / network connectivity.');
    };
    document.head.appendChild(script);
  }

  /**
   * Executes reCAPTCHA Enterprise (score-based) and resolves with the generated token.
   * Returns null if the token could not be generated (e.g. script not loaded).
   */
  executeRecaptchaEnterprise(action = 'submit'): Promise<string | null> {
    return new Promise((resolve) => {
      if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
        console.error('reCAPTCHA Enterprise script not loaded');
        resolve(null);
        return;
      }
      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise
          .execute(this.siteKey, { action })
          .then((token: string) => this.ngZone.run(() => resolve(token)))
          .catch((err: any) => {
            console.error('reCAPTCHA Enterprise execution failed', err);
            this.ngZone.run(() => resolve(null));
          });
      });
    });
  }

  handleExpire() {
    this.captchaSuccess = false;
    this.captchaResponse = null;
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
  }
  setUtmQueryParams(){
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramHandlingService.addQueryParamToObj('utm_source',params['utm_source']);
      this.paramHandlingService.addQueryParamToObj('utm_medium',params['utm_medium']);
      this.paramHandlingService.addQueryParamToObj('utm_campaign',params['utm_campaign']);
    });
  }
}
